<nx-pageTitle-box class="mb-3" 
  [label]="'core.userList.pageTitleBox.label'" 
  [icon]="'icon-person'" 
  [iconToolTip]="'core.userList.pageTitleBox.iconToolTip'"
  [bcRootLvlLabel]="'core.settings.label'"
  [bcRootLvlPath]="'settings'">
</nx-pageTitle-box>

<nx-table-header
  label="core.userList.tableHeader.label">
  <ng-template nxTemplate="end">
    <nx-default-button
      (click)="createUser()"
      [style]="'light'"
      [label]="'core.userList.tableHeader.addUser'"
      [icon]="'icon-plus'">
    </nx-default-button>
  </ng-template>
</nx-table-header>

<p-table
  #userTable
  [lazy]="true"
  (onLazyLoad)="loadData($any($event))"
  [value]="dataSource?.data" 
  [scrollable]="true"
  [paginator]="true"
  [rows]="15"
  [rowsPerPageOptions]="[15, 20, 50]"
  [totalRecords]="dataSource?.totalElements"
  [loading]="loading"
  [sortField]="sortProperty" 
  [sortOrder]="translateSortDirectionToSortOrder(sortDirection)"
  [showCurrentPageReport]="true"
  [filterDelay]="200"
  [currentPageReportTemplate]="'{first} - {last} ' + ('core.common.paginator.currentPageReportSpacer' | translate) +' {totalRecords}'"
  [resizableColumns]="true">
  <ng-template pTemplate="caption">
    <div class="flex flex-row">
      <div class="basis-2/3 flex flex-row gap-2">
        <p-columnFilter class="licenceType" field="licenceType" matchMode="in" [showMenu]="false" [showMatchModes]="false"
          [showOperator]="false" [showAddButton]="false" [showApplyButton]="false" [showClearButton]="false"
          [showButtons]="false">
          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
            <nx-filter-multiSelect
              [className]="'table-filter'"
              [filter]="false"
              [showToggleAll]="false"
              [showHeader]="false"
              [appendTo]="'body'"
              [(ngModel)] = "licenceTypesModel"
              [options]="licenceTypes"
              [showClear]="true"
              [placeholder]="'core.userList.licence' | translate"
              (onClear)="filter($event)"
              (onChange)="filter($any($event).value)"
              optionLabel="name">
            </nx-filter-multiSelect>
          </ng-template>
        </p-columnFilter>
        <p-columnFilter class="enabled" field="enabled" matchMode="in" [showMenu]="false" [showMatchModes]="false"
          [showOperator]="false" [showAddButton]="false" [showApplyButton]="false" [showClearButton]="false"
          [showButtons]="false" >
          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
            <!-- <nx-filter-multiSelect
              [className]="'table-filter'"
              [filter]="false"
              [showToggleAll]="false"
              [showHeader]="false"
              [appendTo]="'body'"
              [(ngModel)] = "statusModel"
              [options]="status"
              [showClear]="true"
              placeholder="Status NOCH OHNE FUNKTION->select"
              (onClear)="filter($event)"
              (onChange)="filter($any($event).value)"
              optionLabel="label">
                <ng-template let-option pTemplate="item">
                  <div class="inline-block vertical-align-middle">
                    <span class="ml-1 mt-1">{{ option.label }}</span>
                  </div>
                </ng-template>
            </nx-filter-multiSelect> -->
            <nx-filter-dropdown
              [className]="'table-filter'"
              [filter]="false"
              [(ngModel)] = "statusModel"
              [appendTo]="'body'"
              [showClear]="true"
              [options]="status | arrayTranslate"
              (onClear)="filter($event)"
              (onChange)="filter($any($event).value)"
              [placeholder]="'core.userList.state' | translate"
              optionLabel="label">
            </nx-filter-dropdown>
          </ng-template> 
        </p-columnFilter>
      </div>
      <div class="basis-1/3 flex flex-row justify-end">
        <p-dropdown
          [placeholder]="'core.userList.table.sorting.placeholder' | translate"
          [styleClass]="'sort'"
          appendTo="body"
          [ngModel] = "sortModel"
          [options]="sortOptions | arrayTranslate"
          optionLabel="label"
          [showClear]="false"
          (onChange)="sort($event)">
        </p-dropdown>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
        <th>{{'core.userList.login' | translate}}</th>
        <th>{{'core.userList.firstName' | translate}}</th>
        <th>{{'core.userList.lastName' | translate}}</th>
        <th>{{'core.userList.licence' | translate}}</th>
        <th>{{'core.userList.state' | translate}}</th>
    </tr>
    <tr>
      <th><p-columnFilter type="text" [showMenu]="false" [placeholder]="'core.common.searchPlaceholder' | translate" field="email" [showClearButton]="true"></p-columnFilter></th>
      <th><p-columnFilter type="text" [showMenu]="false" [placeholder]="'core.common.searchPlaceholder' | translate" field="firstName" [showClearButton]="true"></p-columnFilter></th>
      <th><p-columnFilter type="text" [showMenu]="false" [placeholder]="'core.common.searchPlaceholder' | translate" field="lastName" [showClearButton]="true"></p-columnFilter></th>
      <th></th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-user>
    <tr class="clickable" (click)="openUser(user)">
      <td>{{user.email}}</td>
      <td>{{user.firstName}}</td>
      <td>{{user.lastName}}</td>
      <!-- <td>{{getLicenceType(user.licenceType)}}</td> -->
      <td>{{user.licenceType?.name}}</td> 
      <td>
        <p-tag 
          [value]="(user?.enabled ? 'core.user.state.enabled' : 'core.user.state.disabled') | translate"
          [severity]="user?.enabled ? 'success' : 'danger'">
        </p-tag>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="8" class="emptyMessage">{{'core.userList.noUsersFound' | translate }}</td>
    </tr>
  </ng-template>
</p-table>
